// Infrastructure
import fixtures from './fixtures.json';

// Domain
import { SourceIncomeRepository } from '../../../domain/repository';
import { SourceIncomeEntity } from '../../../domain/entities/source-income-entity';
import Injectable from '@/modules/shared/domain/di/injectable';

@Injectable()
export default class SourceIncomeDummyRepository implements SourceIncomeRepository {
  // eslint-disable-next-line class-methods-use-this
  execute(): Promise<Array<SourceIncomeEntity>> {
    return Promise.resolve(fixtures);
  }
}
